import { render, staticRenderFns } from "./TableLimits.vue?vue&type=template&id=370408ba&scoped=true&"
import script from "./TableLimits.vue?vue&type=script&lang=js&"
export * from "./TableLimits.vue?vue&type=script&lang=js&"
import style0 from "./TableLimits.vue?vue&type=style&index=0&id=370408ba&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "370408ba",
  null
  
)

export default component.exports